<template>
    <div>
        <el-dialog
            title="用户详情"
            :visible.sync="showdialog"
            width="1200px"
            :before-close="back">

            <div class="base-warp">
                <el-form :model="userInfo" ref="form" label-width="80px" :inline="false" size="small">
                    <el-form-item label="姓名">
                        <el-input v-model="userInfo.name"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号">
                        <el-input v-model="userInfo.telephone"></el-input>
                    </el-form-item>
                    <el-form-item label="后台密码">
                        <el-input v-model="userInfo.password"></el-input>
                    </el-form-item>
                    <el-form-item label="辖区">
                        <el-cascader
                        :options="dists"
                        :props="{ checkStrictly: true , label: 'text'}"
                        v-model="userInfo.dist"
                        @change="handleDistChange"
                        clearable></el-cascader>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="small" @click="save">保存</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showdialog: true,
            id: '',
            userInfo: {
                password: '123456',
            },
            dists: [],
            modeTemp: '',
            modearr: ['city', 'district', 'police', 'community'],
        }
    },
    mounted () {
        this.id = this.$route.query.id;
        if (this.id) this.getUserDetail();
        this.getDists();
    },
    methods: {
        handleDistChange(value) {
            var length = value.length;
            var index = this.modearr.indexOf(this.modeTemp);
            if (length>0) {
                this.userInfo.value = value[length-1];
                this.userInfo.mode = this.modearr[index+length-1];
            } else {
                this.userInfo.value = '';
                this.userInfo.mode = '';
            }
        },
        getDists() {
            var that = this;
            this.$api.get_user_distv1('').then(data=>{
                that.dists = data;
                if (data.length>0) {
                    that.modeTemp = data[0]['mode'];

                }
            })
        },
        getUserDetail() {
            var that = this;
            var params = {
                id: this.id,
            }
            this.$api.detailUserV1(params).then(data=>{
                if (typeof data.security == 'object') {
                    data.security.splice(0, 1);
                    data.dist = data.security;
                } else {
                    data.dist = data.value;
                }
                // console.log(data.dist)
                data.password = '';
                that.userInfo = data;
            })
        },
        save() {
            if (this.id) this.edit();
            if (!this.id) this.add();
        },
        add() {
            var that = this;
            var params = this.userInfo;
            this.$api.addUserV1(params).then(()=>{
                this.$confirm('添加成功');
                that.back();
            })
        },
        edit() {
            var that = this;
            var params = this.userInfo;
            this.$api.editUserV1(params).then(()=>{
                this.$confirm('编辑成功');
                that.back();
            })
        },
        back() {
            this.$router.go(-1);
        }
    },
}
</script>

<style lang="scss" scoped>

</style>